export const getSortableClass = (label, sortingValueObj) =>{
    return sortingValueObj?.column === label ? sortingValueObj?.direction : ""

}